export default "__VITE_ASSET__bskCncFO__"